import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../../components/pageTitle";
import {
  handleAllProducts,
  resetAllSummeryData,
} from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import ProductForm from "./form";

const CreateProduct = () => {
  const [data, setData] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const allProducts = useSelector((state) => state.allProducts);
  const { products } = allProducts;
  const handleSumbit = () => {
    setLoadingSubmit(true);
    axiosInstance
      .post(
        API.info.product,
        {
          ...data,
          guidStuffRecNo: data?.guidStuffRecNo?.guidRecNo,
          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          dispatch(resetAllSummeryData());
          /*  navigate("/sell/products") */
          var message = res?.data?.message;
          if (products?.page !== undefined) {
            axiosInstance
              .get(
                API.info.productItem +
                  `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${res?.data.data}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "Accept-Language": "fa-IR",
                    chHostName: process.env.REACT_APP_CHHOSTNAME,
                  },
                }
              )
              .then((res) => {
                toast.success(message);
                var temp = [...products.rows];
                temp.push(res?.data?.data);
                dispatch(handleAllProducts({ ...products, rows: temp }));
                setLoadingSubmit(false);
                navigate("/sell/products");
              })
              .catch((err) => {
                setLoadingSubmit(false);
              });
          } else {
            toast.success(message);
            navigate("/sell/products");
          }
        } else {
          toast.error(res?.data?.message);
        }
        setLoadingSubmit(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoadingSubmit(false);
        /*      if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    axiosInstance
      .get(API.info.sellerLast + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setData({ ...data, chSaleSoftID: res.data.data.chNextSaleSoftID });
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
          {
            title: "کالا/خدمت",
            path: "/sell/products",
          },
        ]}
        title={"ساخت کالا/خدمت"}
      />
      <ProductForm
        data={data}
        setData={setData}
        handleSumbit={handleSumbit}
        loadingSubmit={loadingSubmit}
      />
    </>
  );
};

export default CreateProduct;
